import { Divider } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Portfolio } from './cnaught-portfolios';

interface PortfolioCardProps {
  onClick: () => void;
  portfolio: Portfolio;
}

function PortfolioCard(props: PortfolioCardProps) {
  const { portfolio, onClick } = props;
  const { id, name, summary, description, primaryImageUrl } = portfolio;

  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardMedia
        sx={{
          height: 200,
          '&.MuiCardMedia-img': {
            objectFit: 'cover',
          },
        }}
        component="img"
        src={primaryImageUrl}
        title={name}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {name}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {summary}
        </Typography>
      </CardContent>
      <CardActions>
        <Stack
          direction="column"
          spacing={1}
          alignItems="center"
          justifyContent="center"
          flexGrow={1}
        >
          <Divider sx={{ width: '30%' }} />
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Button size="small" onClick={onClick}>
              Choose
            </Button>
          </Stack>
        </Stack>
      </CardActions>
    </Card>
  );
}

export { PortfolioCard };
